__turbopack_context__.v({
  "component": "index-module__x2NdaW__component",
  "component__body": "index-module__x2NdaW__component__body",
  "component__body_dark": "index-module__x2NdaW__component__body_dark",
  "component__button": "index-module__x2NdaW__component__button",
  "component__close": "index-module__x2NdaW__component__close",
  "component__close_dark": "index-module__x2NdaW__component__close_dark",
  "component__dialog": "index-module__x2NdaW__component__dialog",
  "component__dialogPanel": "index-module__x2NdaW__component__dialogPanel",
  "component__dialogScrim": "index-module__x2NdaW__component__dialogScrim",
  "component__frontierLogo": "index-module__x2NdaW__component__frontierLogo",
  "component__header": "index-module__x2NdaW__component__header",
  "component__helperText": "index-module__x2NdaW__component__helperText",
  "component__icon": "index-module__x2NdaW__component__icon",
  "component__list": "index-module__x2NdaW__component__list",
  "component__modalChrome": "index-module__x2NdaW__component__modalChrome",
  "component__modalContainer": "index-module__x2NdaW__component__modalContainer",
  "component__modalContainer_dark": "index-module__x2NdaW__component__modalContainer_dark",
  "component__steps": "index-module__x2NdaW__component__steps",
  "component__text": "index-module__x2NdaW__component__text",
  "hide-for-large": "index-module__x2NdaW__hide-for-large",
  "hide-for-large-only": "index-module__x2NdaW__hide-for-large-only",
  "hide-for-medium": "index-module__x2NdaW__hide-for-medium",
  "hide-for-medium-only": "index-module__x2NdaW__hide-for-medium-only",
  "hide-for-small-only": "index-module__x2NdaW__hide-for-small-only",
  "show-for-large": "index-module__x2NdaW__show-for-large",
  "show-for-large-only": "index-module__x2NdaW__show-for-large-only",
  "show-for-medium": "index-module__x2NdaW__show-for-medium",
  "show-for-medium-only": "index-module__x2NdaW__show-for-medium-only",
  "show-for-small-only": "index-module__x2NdaW__show-for-small-only",
  "u-color-black": "index-module__x2NdaW__u-color-black",
  "u-color-blue": "index-module__x2NdaW__u-color-blue",
  "u-color-midnight": "index-module__x2NdaW__u-color-midnight",
  "u-color-primary-dark": "index-module__x2NdaW__u-color-primary-dark",
  "u-color-red": "index-module__x2NdaW__u-color-red",
  "u-color-white": "index-module__x2NdaW__u-color-white",
  "u-theme-black": "index-module__x2NdaW__u-theme-black",
  "u-theme-blue": "index-module__x2NdaW__u-theme-blue",
  "u-theme-dark": "index-module__x2NdaW__u-theme-dark",
  "u-theme-light": "index-module__x2NdaW__u-theme-light",
  "u-theme-red": "index-module__x2NdaW__u-theme-red",
  "u-theme-white": "index-module__x2NdaW__u-theme-white",
});
